import { render, staticRenderFns } from "./paginate.vue?vue&type=template&id=eb38ca88&scoped=true"
import script from "./paginate.vue?vue&type=script&lang=js"
export * from "./paginate.vue?vue&type=script&lang=js"
import style0 from "./paginate.vue?vue&type=style&index=0&id=eb38ca88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb38ca88",
  null
  
)

export default component.exports